<template>
  <div class="">
    <nav class="navbar navbar-expand-lg navbar-light bg-light navbar position-sticky w-100 ">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav justify-content-center w-100">
          <li class="nav-item">
            <router-link
                    to="/"
                    class="nav-link navtest"
                    active-class="home-active">
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    to="/gallery"
                    class="nav-link navtest">
              <a>Galerie</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    active-class="active"
                    to="/preise"
                    class="nav-link navtest">
              <a>Preise</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    to="/studio"
                    class="nav-link navtest">
              <a>Fotostudio</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    to="/about"
                    class="nav-link navtest">
              <a>Über mich</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    to="/kontakt"
                    class="nav-link navtest">
              <a>Kontakt</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
                    to="/impressum"
                    class="nav-link navtest">
              <a>Impressum</a>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: "Navbar"
  }
</script>

<style scoped>
  .fixed-nav {
    position: fixed;
    top: 0;
    opacity: 1;
    z-index: 1050;
  }
  .navtest {
    border-bottom: 3px solid transparent;
    color: #000;
    transition: border-bottom-color 50ms linear 0s;

  }
  .navtest:hover, .router-link-exact-active, .router-link-active {
    border-bottom-color: #4b4b4b;
  }
</style>